import { defineComponent as c, useSlots as i, computed as t, openBlock as r, createElementBlock as s, normalizeClass as p, normalizeStyle as f, renderSlot as a, createCommentVNode as h } from "vue";
import { _ as m } from "../_plugin-vue_export-helper-CHgC5LLL.js";
import '../Card.css';const _ = {
  key: 0,
  class: "footer"
}, v = /* @__PURE__ */ c({
  __name: "Card",
  props: {
    height: { default: "inherit" },
    border: { type: Boolean, default: !0 },
    rounded: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    classes: { default: () => ({}) }
  },
  setup(n) {
    const o = n, d = i(), l = t(() => {
      var e;
      return ["card-container", { "!border-0": !o.border, "!rounded-none": !o.rounded, "!shadow-none": !o.shadow }, (e = o.classes) == null ? void 0 : e.container];
    }), u = t(() => d.footer);
    return (e, y) => (r(), s("div", {
      class: p(l.value),
      style: f({ height: e.height })
    }, [
      a(e.$slots, "default", {}, void 0, !0),
      u.value ? (r(), s("div", _, [
        a(e.$slots, "footer", {}, void 0, !0)
      ])) : h("", !0)
    ], 6));
  }
}), S = /* @__PURE__ */ m(v, [["__scopeId", "data-v-3eedc718"]]);
export {
  S as default
};
//# sourceMappingURL=Card.esm.js.map
